"use client";

import { Fragment, useSyncExternalStore } from "react";
import { splitPhrases } from "./phrases";

const noopSubscribe = () => () => {};

/**
 * 文節の切れ目にだけ折り返しの候補（<wbr>）を置いて文字を出す。
 * 親に word-break: keep-all を付けて使う。文節の分け方はブラウザの辞書で決まるので、サーバーでは分けずに描く。
 */
export default function PhraseText({ text }: { text: string }) {
  const isClient = useSyncExternalStore(noopSubscribe, () => true, () => false);
  // 空の文（「文言」で使わないにした文）は何も出さない。折る印（wbr）だけが残ると、包んだ箱が空の箱として消えずに1行ぶん残る
  if (!text) return null;
  const phrases = isClient ? splitPhrases(text) : [text];
  return (
    <>
      {phrases.map((p, i) => (
        <Fragment key={i}>
          {p}
          <wbr />
        </Fragment>
      ))}
    </>
  );
}
